Vue.asyncComponent('cms-welcome', {
    data() {
        return {
            user: this.$userInterfaceHandler.getUserInterface()?.user,
            avatar: this.$userInterfaceHandler.getUserInterface()?.avatar,
        }
    },
    methods: {
        /**
         * Redirect to profile
         */
        redirectToProfile() {
            this.$router.push({
                name: 'form',
                params: {
                    bundle: 'cms-user',
                    gridDefinition: 'grid',
                    definition: 'profile',
                    objectId: this.user.id
                }
            });
        },
        /**
         * Redirect to change password
         */
        redirectToChangePassword() {
            this.$router.push({
                name: 'form',
                params: {
                    bundle: 'cms-user',
                    gridDefinition: 'grid',
                    definition: 'change-password',
                    objectId: this.user.id
                }
            });
        }
    }
}, 'cms/account/cms-welcome.html');